import { getFetch } from '@legacy/utils/fetcher';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { IOverdueInvoices } from '@legacy/apis/types/overdueInvoicesAPI';
import { concatQueries } from '@legacy/utils/url';
import { IPaginationModel } from '@legacy/apis/types/paginationModelAPI';

const GET_OVERDUE_INVOICES_REPORTING_WIDGET_URL_PATH =
  '/api/v2/insights-service/overdue-invoice';
const GET_OVERDUE_INVOICES_REPORTING_WIDGET_MSW_STATUS_KEY =
  'getOverdueInvoicesAPI';

const GET_OVERDUE_INVOICES_REPORTING_WIDGET_KEY =
  'GET_OVERDUE_INVOICES_REPORTING_WIDGET_KEY';

const getOverdueInvoicesReportingWidget = (
  page: number = 0,
  pageSize: number = 0,
): Promise<IOverdueInvoices> =>
  getFetch({
    path: `${GET_OVERDUE_INVOICES_REPORTING_WIDGET_URL_PATH}${concatQueries([
      { param: '$pagesize', value: pageSize.toString() },
      { param: '$page', value: page.toString() },
    ])}`,
    key: GET_OVERDUE_INVOICES_REPORTING_WIDGET_MSW_STATUS_KEY,
  });

export const useGetOverdueInvoicesReportingWidget = ({
  page,
  pageSize,
}: IPaginationModel) => {
  const { data, ...restProps } = useQuery({
    queryKey: [GET_OVERDUE_INVOICES_REPORTING_WIDGET_KEY, page, pageSize],
    queryFn: () => getOverdueInvoicesReportingWidget(page + 1, pageSize),
    placeholderData: keepPreviousData,
  });

  if (data?.properties) {
    return {
      widgetName: data?.properties.type,
      widgetData: data?.properties.data,
      currencyAbb: data?.properties.baseCurrencyAbb,
      paginationInfo: {
        page: data?.properties.paginationInfo.pageNumber,
        totalRecord: data?.properties.paginationInfo.totalRecord,
      },
      ...restProps,
    };
  }

  return {
    widgetName: '',
    widgetData: [],
    currencyAbb: '',
    paginationInfo: {
      page: 0,
      totalRecord: 0,
    },
    ...restProps,
  };
};
